module.exports = __webpack_public_path__ + "img/Statistics.3344f39c.svg";